import { useEffect } from 'react';

import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { useEntityPageStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

export const EditorUrlParameter: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isEditor = useEntityPageStore(
    ({ pageContext }) => pageContext.isEditor
  );
  const setIsEditing = useEditStore(({ setIsEditing }) => setIsEditing);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (params.has('edit') && isEditor) {
      setIsEditing(true);
    }
  }, []);

  return children;
};
